import { render, staticRenderFns } from "./TaskAssign.vue?vue&type=template&id=367c1108&"
import script from "./TaskAssign.vue?vue&type=script&lang=js&"
export * from "./TaskAssign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports